import React, { useState } from "react";
import PermisosSelection from "./PermisosSelection";
import { permisions } from "../../../utils/helpers";

const Reportes = ({reportesUsuario}) => {
    const grupoA = [
        {
            label: 'Salud',
            value: permisions.reporteSalud,
            children: [
                { label: 'Visitas', value: permisions.reporteSaludVisitas },
                { label: 'Insumos', value: permisions.reporteSaludInsumos },
            ],
        },
        {
            label: 'Contabilidad',
            value: permisions.reporteContabilidad,
            children: [
                { label: 'Cuentas', value: permisions.reporteContabilidadCuentas },
                { label: 'Transacciones', value: permisions.reporteContabilidadTransacciones },
                { label: 'Cheques', value: permisions.reporteContabilidadCheques },
                { label: 'Entrada Diario', value: permisions.reporteContabilidadEntradaDiario },
            ],
        },
        { label: 'Contratos', value: permisions.reporteContratos },
        {
            label: 'Ingreso',
            value: permisions.reporteIngreso,
            children: [
                { label: 'Facturas', value: permisions.reporteFacturaReporteFacturas },
                { label: 'Resumen facturas', value: permisions.reporteFacturaResumenFacturas },
                { label: 'Detalle impuesto', value: permisions.reporteFacturaDetalleImpuesto },
                { label: 'Cuadre caja', value: permisions.reporteFacturaCuadreCaja },
                { label: 'Cuadre caja resumido', value: permisions.reporteFacturaCuadreCajaResumido },
                { label: 'Lista carga', value: permisions.reporteFacturaListaCarga },
                { label: 'Balance', value: permisions.reporteFacturaBalance },
                { label: 'Balance Detalle', value: permisions.reporteFacturaBalanceDetalle },
                { label: 'Ruta Distribución', value: permisions.reporteFacturaRutaDistribucion },
                { label: 'Planificación de tareas', value: permisions.reporteFacturaPlanificacionTareas },
                { label: 'Cuadre caja ventas', value: permisions.reporteFacturaCuadreCajaVentas },
                { label: 'Factura recurrente', value: permisions.reporteFacturaRecurentes },
                { label: 'Cotizaciones', value: permisions.reporteCotizaciones },
                { label: 'Ordenes compra detalles', value: permisions.reporteOrdenesCompraDetalles },
                { label: 'Ordenes compra resumen', value: permisions.reporteOrdenesCompraResumen },
                { label: 'Ordenes compra lista entrega', value: permisions.reporteOrdenesCompraListaEntrega },
                { label: 'Ordenes reporte cuadre de caja', value: permisions.reporteOrdenesCuadreCaja },
                { label: 'Ordenes reporte cuadre de caja de venta', value: permisions.reporteOrdenesCuadreCajaVenta },
                { label: 'Despacho: Lista carga', value: permisions.reporteDespachoFacturasListaCarga },
                { label: 'Despacho: Orden carga', value: permisions.reporteDespachoFacturasOrdenCarga },
                { label: 'Despacho factura', value: permisions.reporteDespachoFacturas },
            ],
        },
        {
            label: 'Consultas',
            value: permisions.reporteConsultas,
            children: [
                { label: 'CxC Detalles', value: permisions.reporteCuentaPorCobrarDetalles },
                { label: 'CXC Estado cuenta', value: permisions.reporteCuentaPorCobrarEstadoCuenta },
                { label: 'CXC Resumen', value: permisions.reporteCuentaPorCobrarResumen },
                { label: 'CXP Detalles', value: permisions.reporteCuentaPorPagarDetalles },
                { label: 'CXP Estado cuenta', value: permisions.reporteCuentaPorPagarEstadoCuenta },
                { label: 'CXP Resumen', value: permisions.reporteCuentaPorPagarResumen },
                { label: 'Recibos', value: permisions.reporteRecibos },
                { label: 'Notas de credito', value: permisions.reporteNotaCredito },
                { label: 'Notas de credito: Detalle Impuestos', value: permisions.reporteNotaCreditoDetalleImpuesto },

            ],
        },
        {
            label: 'Empleados',
            value: permisions.reporteEmpleados,
            children: [
                { label: 'Listado Empleados', value: permisions.reporteEmpleadosListado },
                { label: 'Detalle Empleados', value: permisions.reporteEmpleadosDetalle },
                { label: 'Comparar Nómina y TSS', value: permisions.reporteEmpleadosCompararNomina },
                { label: 'Cumpleaños', value: permisions.reporteEmpleadosCumpleanos },
                { label: 'Salario Navidad', value: permisions.reporteEmpleadosSalarioNavidad },
                { label: 'Salario Navidad Detalle', value: permisions.reporteEmpleadosSalarioNavidadDetalle },
                { label: 'Sobres Salario Navidad', value: permisions.reporteEmpleadosSalarioNavidadSobre },
                { label: 'Desglose Salario Navidad', value: permisions.reporteEmpleadosSalarioNavidadDesgloses },
                { label: 'Volantes Salario Navidad', value: permisions.reporteEmpleadosSalarioNavidadVolantes },
                { label: 'Apertura de cuenta BR', value: permisions.reporteEmpleadosAperturaCuentaBR },
                { label: 'Vacaciones Pendientes', value: permisions.reporteEmpleadosVacacionesPendientes },
            ],
        },
        {
            label: 'Ausencias',
            value: permisions.reporteAusencias,
            children: [
                { label: 'Generales', value: permisions.reporteAusenciasGeneral },
                { label: 'Vacaciones', value: permisions.reporteAusenciasVacaciones },
            ],
        },
    ];

    const grupoB = [
        { label: 'Descuentos', value: permisions.reporteDescuentos },
        { label: 'Incentivos', value: permisions.reporteIncentivos },
        { label: 'Tareas', value: permisions.reporteSolicitudes },
        {
            label: 'Vehículos',
            value: permisions.reporteVehiculos,
            children: [
                { label: 'Listado Vehículos', value: permisions.reporteVehiculosListado },
                { label: 'Detalle Vehículos', value: permisions.reporteVehiculosLDetalle },
            ],
        },
        { label: 'Servicios', value: permisions.reporteServicios },
        { label: 'Zonas', value: permisions.reporteZonas },
        {
            label: 'Inventario',
            value: permisions.reporteInventario,
            children: [
                { label: 'Productos: Realizar Inventario', value: permisions.reporteInventarioProductosRealizarInventario },
                { label: 'Productos: Inventario', value: permisions.reporteInventarioProductosInventario },
                { label: 'Productos: Reorden', value: permisions.reporteInventarioProductosReordern },
                { label: 'Productos: Balance Inventario', value: permisions.reporteInventarioProductosBalance },
                { label: 'Productos: Operaciones de Inventario', value: permisions.reporteInventarioProductosOperaciones },
                { label: 'Productos: Inventario Ventas', value: permisions.reporteInventarioProductosInventarioCentas },
                { label: 'Productos: Productos por Suplidor', value: permisions.reporteInventarioProductosPorSuplidor },
                { label: 'Activos fijos', value: permisions.reporteInventarioActivoFijos },
                { label: 'Activos fijos reorden', value: permisions.reporteInventarioActivoFijosReorden },
                { label: 'Reporte Compras', value: permisions.reporteInventarioCompras },
                { label: 'Cuadre de Compra', value: permisions.reporteInventarioComprasCuadre },
                { label: 'Compras: Detalle Impuestos', value: permisions.reporteInventarioComprasDetalleImpuesto },
                { label: 'Despachos internos', value: permisions.reporteInventarioDespachoInterno },
            ],
        },
    ];

    const [currentReport, setCurrentReport] = useState(
        new Set([
            ...(reportesUsuario ?? []),
        ])
    );

    const addToCurrent = (reportes) => {
        setCurrentReport((prev) => new Set([...prev, ...reportes]));
    };

    const removeFromCurrent = (reportes) => {
        setCurrentReport((prev) => {
            const next = new Set(prev);

            for (const reporte of reportes) {
                next.delete(reporte);
            }

            return next;
        });
    };

    return <>
        <div className="form-group row">
           <div className="col-12 py-1" style={{lineHeight: 1.1}}>
                <label style={{fontSize: '18px', fontWeight: 700, color: '#333'}}>Permisos de reportes</label>

                <span style={{color: '#777', fontSize: '14px'}}>Selecciona los reportes a los que tendrá acceso este usuario</span>
            </div>
        </div>

        <div className="row" style={{height: 'calc(100% - 60px)'}}>
            {[...currentReport].filter((report) => report).map((report, index) => <input type="hidden" name="permisos[]" value={report} key={`reportes[${index}]`} />)}
            <div className="col-6" style={{height: '100%'}}>
                <div style={{width: '100%', height: '100%' }}>
                    {grupoA.map((session, index) =>
                        <PermisosSelection key={`p-session[${index}]`} label={session.label} value={session.value} children={session.children} current={[...currentReport]} add={addToCurrent} remove={removeFromCurrent} />
                    )}
                </div>
            </div>

            <div className="col-6" style={{height: '100%'}}>
                <div style={{width: '100%', height: '100%' }}>
                    {grupoB.map((session, index) =>
                        <PermisosSelection key={`p-session[${index}]`} label={session.label} value={session.value} children={session.children} current={[...currentReport]} add={addToCurrent} remove={removeFromCurrent} />
                    )}
                </div>
            </div>
        </div>
    </>;
};

export default Reportes;